// Test IDs for the home / landing feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const HOME = {
        emergentLink: 'home-emergent-link',
        phoneCallButton: 'home-phone-call-button',
        getEstimateButton: 'home-get-estimate-button',
        leadFormName: 'lead-form-name-input',
        leadFormEmail: 'lead-form-email-input',
        leadFormPhone: 'lead-form-phone-input',
        leadFormAddress: 'lead-form-address-input',
        leadFormCity: 'lead-form-city-select',
        leadFormService: 'lead-form-service-select',
        leadFormSqft: 'lead-form-sqft-input',
        leadFormDetails: 'lead-form-details-input',
        leadFormSubmit: 'lead-form-submit-button',
        visualizerSwatchSilver: 'visualizer-swatch-silver-metallic',
        visualizerSwatchClassic: 'visualizer-swatch-classic-gray',
        visualizerSwatchDesert: 'visualizer-swatch-desert-tan',
        visualizerSwatchRoyal: 'visualizer-swatch-royal-blue',
        sliderContainer: 'before-after-slider-container',
        sliderHandle: 'before-after-slider-handle',
};
